import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import callAPI from '../../../../api';

export const getProfessionsNearestByDescription = createAsyncThunk(
  'professions/getProfessionsNearestByName',
  async (nearestDescription) => {
    const { data } = await callAPI({
      method: 'GET',
      url: `professions/nearest/${nearestDescription}`,
    });
    return data;
  },
);

const INITIAL_STATE = [{ label: '', id: undefined }];

export const professionsSlice = createSlice({
  name: 'professions',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: {
    [getProfessionsNearestByDescription.fulfilled]: (state, { payload }) => {
      return payload.map((profession) => {
        return {
          label: profession.description,
          id: profession.id,
        };
      });
    },
  },
});

export default professionsSlice.reducer;
